import React from 'react';
import PropTypes from 'prop-types';
import SearchIcon from '../..//icons/SearchIcon';

const GDGolbalFilterSelectorRecentSearchListItem = (props) => {
  const { searchItem, onRecentSearch } = props;
  const  acquirerCode = JSON.parse(sessionStorage.getItem("state")).auth.user.acquirerCode;
  const  isHpyAcquirer = (JSON.parse(sessionStorage.getItem("state")).auth.user.acquirerCode==='HPY'?true:false)
  return (
    <div
      key={`gdhs-recent-search-${searchItem.id}`}
      className={searchItem.isEmpty ? 'gd-hierarchy-selector-recent-search-list__itemsearch' : 'gd-hierarchy-selector-recent-search-list__item __'+acquirerCode  }
      onClick={searchItem.isEmpty ? null : () => onRecentSearch(searchItem.searchType, searchItem.searchText, searchItem.query)}
      role="button"
      aria-label={searchItem.searchText}
      tabIndex="-1"

    >
      <div className="gd-hierarchy-selector__sub-icon-container" >
        {!searchItem.isEmpty && <div className={'gd-hierarchy-selector__sub-icon __'+acquirerCode+ ' search-icon-view'}> <SearchIcon /></div>}
      </div>
      {!searchItem.isEmpty && '"'}{!searchItem.isEmpty && searchItem.searchText}{!searchItem.isEmpty && '"'}<div style={{color: searchItem.query === "Search for…" ? "#C4C4C4" : "#595959", marginLeft: 5  }} >{searchItem.query}</div>    </div>

  );
};

GDGolbalFilterSelectorRecentSearchListItem.propTypes = {
  searchItem: PropTypes.object,
  onRecentSearch: PropTypes.func,
};
GDGolbalFilterSelectorRecentSearchListItem.defaultProps = {
  searchItem: {},
  onRecentSearch: () => { },
};

export default GDGolbalFilterSelectorRecentSearchListItem;
